import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
import { AnimationInline } from '../AnimationOverlay';
import './GameInstructionsContent.css';
import { useStore } from '@tmsw/powerups.store';

export function GameInstructionsContent() {
  const { __t } = useTranslation('GAME_INSTRUCTIONS');
  const [bodyCopy1, bodyCopy1Sub] = __t('bodyCopy1').split(`\n\n`);
  const [bodyCopy2, bodyCopy2Sub] = __t('bodyCopy2').split(`\n\n`);
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);

  return (
    <div className="game-instructions-content">
      <div className="game-instructions-text">
        <p className="paragraph-instructions">{bodyCopy1}</p>
        <p className="subparagraph-instructions">
          <i>{bodyCopy1Sub}</i>
        </p>
        <br></br>
        <p className="paragraph-instructions">{bodyCopy2}</p>
        <p className="subparagraph-instructions">
          <i>{bodyCopy2Sub}</i>
        </p>
      </div>
      {/* @ts-ignore */}
      {!showSettingsPanel ? (
        <AnimationInline
          name="TUTORIAL"
          type="LOTTIE"
          url={__t('lottieFile')}
          unique={true}
          loop={false}
          style={{
            width: '100vw',
            height: 'auto',
            marginTop: '-15%',
            marginBottom: '-5%',
          }}
        />
      ) : null}
    </div>
  );
}
